var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "res-input"
  }, [_vm.printRead ? [_c('span', {
    staticClass: "res-print-read m-l-5"
  }, [_vm._v(_vm._s(_vm.dataModel))])] : [_c('el-input', _vm._g(_vm._b({
    style: _vm.styleWidth,
    attrs: {
      "type": "text",
      "disabled": !_vm.edit || _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_vm._t("prepend")];
      },
      proxy: true
    }, {
      key: "append",
      fn: function () {
        return [_vm._t("append")];
      },
      proxy: true
    }, {
      key: "prefix",
      fn: function () {
        return [_vm._t("prefix")];
      },
      proxy: true
    }, {
      key: "suffix",
      fn: function () {
        return [_vm._t("suffix")];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.dataModel,
      callback: function ($$v) {
        _vm.dataModel = $$v;
      },
      expression: "dataModel"
    }
  }, 'el-input', _vm.$attrs, false), _vm.$listeners)), _vm.description ? _c('div', {
    staticClass: "cmp-desc"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()]], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };